import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { EnrichedBulletList } from '../interactions/EnrichedBulletList.jsx'

/**
 * WinsCard — enriched bullets with attribution chip.
 * catalog #4, prep-wins. Reuses EnrichedBulletList (suffixType='attribution').
 */
export function WinsCard({ card, value, onChange, disabled }) {
  const items = value?.items ?? []

  return (
    <CardFrame
      kind="prep"
      icon="◆"
      iconClass="moss"
      title="Wins"
      prompt="What went well this week?"
      state={disabled ? 'locked' : items.some((i) => i.text) ? 'filled' : 'empty'}
      data-testid="prep-card-prep-wins"
      className="prepcard"
    >
      <EnrichedBulletList
        items={items}
        onChange={onChange}
        suffixType="attribution"
        maxItems={15}
        maxChars={200}
        placeholder="Something that went well…"
        disabled={disabled}
      />
    </CardFrame>
  )
}
